import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import {MstUnitService} from '../configuration/mst-unit/mst-unit.service';
import {OtDetailsService} from '../operation-theater/ot-details/ot-details.service';
import {ChecklistDetailsService} from '../operation-theater/ot-schedule/checklist-details/checklist-details.service';
import {EquipmentDetailsService} from '../operation-theater/ot-schedule/equipment-details/equipment-details.service';
import {IntraOperativeInstructionDetailsService} from '../operation-theater/ot-schedule/intra-operative-instruction-details/intra-operative-instruction-details.service';
import {StaffDetailsService} from '../operation-theater/ot-schedule/staff-details/staff-details.service';
import {PostOperativeInstructionDetailsService} from '../operation-theater/ot-schedule/post-operative-instruction-details/post-operative-instruction-details.service';
import {ConcentDetailsService} from '../operation-theater/ot-schedule/concent-details/concent-details.service';
import {PreOperativeInstructionDetailsService} from '../operation-theater/ot-schedule/pre-operative-instruction-details/pre-operative-instruction-details.service';
import {DoctorDetailsService} from '../operation-theater/ot-schedule/doctor-details/doctor-details.service';
import {ServiceDetailsService} from '../operation-theater/ot-schedule/service-details/service-details.service';
import {ProcedureDetailsService} from '../operation-theater/ot-schedule/procedure-details/procedure-details.service';

@Component({
    selector: 'app-ot-summary',
    templateUrl: './ot-summary.component.html',
    styleUrls: []
})
export class OtSummaryComponent implements OnInit {

    mstUnit: any = {};
    currentPatient: any = {};
    unitid: any ;
    opdId: any ;
    otDetails: any = {};
    otProcedure: any[];
    otService: any[];
    otChecklist: any[];
    otConsent: any[];
    otPreInstruction: any[];
    otIntraInstruction: any[];
    otPostInstruction: any[];
    otEquipment: any[];
    otDoctor: any[];
    otStaff: any[];

    constructor(private router: Router,
                private mstUnitService: MstUnitService,
                private checklistDetailsService: ChecklistDetailsService,
                private procedureDetailsService: ProcedureDetailsService,
                private concentDetailsService: ConcentDetailsService,
                private equipmentDetailsService: EquipmentDetailsService,
                private preOperativeInstructionDetailsService: PreOperativeInstructionDetailsService,
                private intraOperativeInstructionDetailsService: IntraOperativeInstructionDetailsService,
                private postOperativeInstructionDetailsService: PostOperativeInstructionDetailsService,
                private doctorDetailsService: DoctorDetailsService,
                private staffDetailsService: StaffDetailsService,
                private serviceDetailsService: ServiceDetailsService,
                private otDetailsService: OtDetailsService) { }


    ngOnInit() {
        this.unitid = JSON.parse(sessionStorage.getItem('unitId'));
        const a = this.router.url.split('/'); //  Delimiter is a string
        this.opdId = a[2];
        this.mstUnitService.getRecordService(this.unitid) .then(resp => { this.mstUnit = resp; this.getOtDetails(); });
    }

    getOtDetails() {
        this.otDetailsService.getRecordService(this.opdId). then(resp => { this.otDetails = resp; this.currentPatient = this.otDetails.opdPatientId; });
        this.procedureDetailsService.getRecordByOpdIdService(this.opdId).then(resp => {  this.otProcedure = resp; console.log(resp);});
        this.checklistDetailsService.getRecordByOpdIdService(this.opdId).then(resp => {  this.otChecklist = resp; });
        this.concentDetailsService.getRecordByOpdIdService(this.opdId).then(resp => {  this.otConsent = resp; });
        this.equipmentDetailsService.getRecordByOpdIdService(this.opdId).then(resp => {  this.otEquipment = resp; });
        this.preOperativeInstructionDetailsService.getRecordByOpdIdService(this.opdId).then(resp => {  this.otPreInstruction = resp; });
        this.intraOperativeInstructionDetailsService.getRecordByOpdIdService(this.opdId).then(resp => {  this.otIntraInstruction = resp; });
        this.postOperativeInstructionDetailsService.getRecordByOpdIdService(this.opdId).then(resp => {  this.otPostInstruction = resp; });
        this.doctorDetailsService.getRecordByOpdIdService(this.opdId).then(resp => {  this.otDoctor = resp; });
        this.staffDetailsService.getRecordByOpdIdService(this.opdId).then(resp => {  this.otStaff = resp; });
        this.serviceDetailsService.getRecordByOpdIdService(this.opdId).then(resp => {  this.otService = resp; });

    }

    printOT(): void {
        let printContents, popupWin;
        printContents = document.getElementById('print-section').innerHTML;
        popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
        popupWin.document.open();
        popupWin.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          
          <link rel="stylesheet" href="assets/css/your_style.css">
          
          <!-- Latest compiled and minified CSS -->
          <link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.1.0/css/bootstrap.min.css">
          
          <!-- jQuery library -->
          <script src="https://ajax.googleapis.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>
          
          <!-- Popper JS -->
          <script src="https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.14.0/umd/popper.min.js"></script>
          
          <!-- Latest compiled JavaScript -->
          <script src="https://maxcdn.bootstrapcdn.com/bootstrap/4.1.0/js/bootstrap.min.js"></script>
          
          <style>
          .pull-right
          {
             float: right;
          }
          @media print {
            body{              
                -webkit-print-color-adjust: exact; 
            }
           }
          
          .ui-grid-col-12 {
              width: 100%;
          }
          .col-xs-12{
              width: 100%;
          }
          
          .col-xs-6{
           width: 100%;
              /*float: left;              */
              /*position: absolute;*/
              /*min-height: 1px;*/
              padding-right: 15px;
              padding-left: 15px;
          }
            
          h5 {
            font-size: 17px;
            font-weight: 300;
            line-height: normal;
          } 
          
          .bordered {
              border: 1px solid rgba(0, 0, 0, .2);
          }
          
          .caseReport .ui-panel-titlebar{
              padding: 0px 0px 0px 10px;
            }
            
            .caseReport h5{
              margin: 5px 0;
            }
            
            .caseReport .ui-widget-header{
              background: #337ab7;
              color: #fff;
              border-color: #337ab7;
            }
            
            .caseReportPrimary .ui-widget-content{
              border: 1px solid #337ab7;
              border-left: 5px solid #337ab7;
            }
            
            .caseReportInfo .ui-widget-content{
              border: 1px solid #17a2b8;
              border-left: 5px solid #17a2b8;
            }
            
            .caseReportWarning .ui-widget-content{
              border: 1px solid #ffc107;
              border-left: 5px solid #ffc107;
            }
            
            .caseReportDanger .ui-widget-content{
              border: 1px solid #dc3545;
              border-left: 5px solid #dc3545;
            }
            
            .caseReportSuccess .ui-widget-content{
              border: 1px solid #28a745;
              border-left: 5px solid #28a745;
            }
            </style>
        </head>
        <body onload="window.print();window.close()">${printContents}</body>
      </html>`
        );
        popupWin.document.close();
        this.navigateBack1();
    }


    navigateBack1() {
        this.router.navigate(['ot/otdetailslist']);
    }


    navigateBack() {
        this.router.navigate(['ot/otdetails/' + this.opdId]);
    }
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/ot-summary/ot-summary.component.ts